import { css } from "@linaria/core"
import { styled } from "@linaria/react"

import { Button } from "@/components/Button/Button.tsx"
import { LockRegular } from "@/icons/Icons.ts"
import { smallFontSize } from "@/styles/textStyles.ts"

export const ToggleSecret = styled(Button)`
  position: absolute;
  right: 0;
  top: 50%;

  transform: translateY(-50%);

  height: auto;
  border: none;
  padding: 0 0 0 8px;

  ${smallFontSize};

  color: var(--secondary-text-color);

  &:hover:not(:disabled) {
    color: var(--secondary-text-color);
    background: var(--background-color);
  }
`

export const ToggleSecret_Offset = css`
  right: 16px; /* Same as the padding of Input_Bordered */
`

export const Input_Borderless = css`
  border: none;
`

export const Input_Bordered = css`
  overflow: hidden;
  min-height: 40px;

  padding: 8px 16px;

  border: 1px solid var(--text-color-10);
  border-radius: var(--border-radius-20);
`

export const Input_WithLockIcon = css`
  padding-left: 32px;
`

export const Input_SingleLine = css`
  width: calc(100% - 48px);
  line-height: 24px;
`

export const LockIconInside = styled(LockRegular)`
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);

  width: 20px;
  height: 20px;

  color: var(--secondary-text-color);
  pointer-events: none;
`